import { cn } from "@theprelude/core";

export const CodeIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path d="M16 8L12.2287 11.7713L11.2859 10.8284L14.1144 8L11.2859 5.17157L12.2287 4.22877L16 8ZM1.88562 8L4.71405 10.8284L3.77123 11.7713L0 8L3.77123 4.22877L4.71405 5.17157L1.88562 8ZM6.52563 14H5.10673L9.4744 2H10.8933L6.52563 14Z" />
  </svg>
);
